var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.validNoOfBets < _vm.env.accaBonusMinSelections && _vm.show)?_c('div',{class:{ 'acca-on-mini-betslip': 1 }},[_c('p',{staticClass:"acca-on-mini-betslip__desc"},[_vm._v("\n\t\t\t"+_vm._s(_vm.$t("betslip.bonus-description-mini", {
					accaBonusMinSelectionsValidNoOfBets:
						_vm.env.accaBonusMinSelections - _vm.validNoOfBets,
					accaBonusMinSelectionsValidNoOfBetsWithS:
						_vm.env.accaBonusMinSelections - _vm.validNoOfBets > 1 ? `s` : ``,
					accaBonusMinimumOdd: _vm.env.accaBonusMinimumOdd,
					accaBonusMatrixAccaBonusMinSelections:
						_vm.env.accaBonusMatrix[_vm.env.accaBonusMinSelections],
					accaBonusProductName: _vm.env.accaBonusProductName,
				}))+"\n\t\t")])]):_vm._e(),_vm._v(" "),(_vm.validNoOfBets >= _vm.env.accaBonusMinSelections && _vm.show)?_c('div',{staticClass:"acca-on-mini-betslip acca-on-mini-betslip--active"},[(_vm.percentage < _vm.max)?_c('p',{staticClass:"acca-on-mini-betslip__desc"},[_vm._v("\n\t\t\t"+_vm._s(_vm._f("currency")(_vm.bonus))+" ("+_vm._s(_vm.percentage)+"%)\n\t\t\t"+_vm._s(_vm.$t("betslip.bonus-activated"))+" 🎉\n\t\t\t"),_c('br'),_vm._v("\n\t\t\t"+_vm._s(_vm.$t("betslip.add-more-bets", {
					nextLevelNextValidNoOfBets: _vm.nextLevel.next - _vm.validNoOfBets,
					nextLevelNextValidNoOfBetsWithS:
						_vm.nextLevel.next - _vm.validNoOfBets > 1 ? `s` : ``,
					accaBonusMinimumOdd: _vm.env.accaBonusMinimumOdd,
					nextLevelPerc: _vm.nextLevel.perc,
					accaBonusProductName: _vm.env.accaBonusProductName,
				}))+"\n\t\t")]):_c('p',{staticClass:"acca-on-mini-betslip__desc"},[_vm._v("\n\t\t\t"+_vm._s(_vm.$t("betslip.reached-max-bonus", {
					accaBonusProductName: _vm.env.accaBonusProductName,
					max: _vm.max,
				}))+"% 🎉\n\t\t")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }